import React from "react";

import Button from "../elements/Button.tsx";
import Header from "../elements/Header.tsx";
import Modal, { ModalProps } from "../elements/Modal.tsx";

type Props = Pick<ModalProps, "onClose">;

const InvalidNonceModal: React.FC<Props> = ({ onClose }) => {
  return (
    <Modal onClose={onClose}>
      <Header size="2xl" hideUnderline className="mb-4">
        {"Your session has expired"}
      </Header>
      <div className="mb-4">
        This can happen if the builder has been open for a long time, or if
        you&apos;ve signed in or out in another tab. Reload the page to get a
        new session.
      </div>
      <Button onClick={() => window.location.reload()}>Reload</Button>
    </Modal>
  );
};

export default InvalidNonceModal;
